import { find } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getAllOrganizationFromCurrentWorkspace,
  getAllPropertiesByOrgIds,
} from "services/MemberService";
import { Spin } from "syngenta-digital-cropwise-react-ui-kit";
import { getIsAppPermitted, isUK, translationWrapper } from "utils/common-methods";
import moveBackArrow from "../../assets/icons/moveBackArrow.svg";
import moveForthArrow from "../../assets/icons/moveForthArrow.svg";
import Frame5064 from "../../assets/images/Frame5064.svg";
import Frame50642 from "../../assets/images/Frame50642.svg";
import Frame5087 from "../../assets/images/Frame5087.svg";
import Frame50875 from "../../assets/images/Frame50875.svg";

import "./styles.less";

interface IDataForTryItApps {
  id: string;
  image: string;
  title: string;
  subTitle: string;
  prepareUrl: boolean;
  tryItAppsLink: string;
}

interface ProductBasicData {
  id: string;
  site_uri: string;
}

export const TryItApps = (props: any) => {
  const { t } = translationWrapper(useTranslation());
  const { products, currentWorkspaceId: workspaceId } = props;
  const [selectedTipNumber, setSelectedTipNumber] = React.useState(1);
  const [filteredDataForTryItApps, setFilteredDataForTryItApps] = useState<IDataForTryItApps[]>([]);

  const dataForTryItApps: IDataForTryItApps[] = [
    {
      id: process.env.REACT_APP_FARM_SETTINGS_ID as string,
      image: Frame5087,
      title: "try_it_app.app.title",
      subTitle: 'try_it_app.app.subtitle',
      prepareUrl : true,
      tryItAppsLink:`HOSTapp/landing-organization/ORG_ID/property/PROPERTY_ID/table-view`
    },
    {
      id: process.env.REACT_APP_PROTECTOR_ID as string,
      image: Frame5064,
      title: "try_it_app.protector.title",
      subTitle: "try_it_app.protector.subtitle",
      prepareUrl : true,
      tryItAppsLink:`HOSTcompany/ORG_ID/property/PROPERTY_ID/timeline`
    },
    {
      id: process.env.REACT_APP_IMAGERY_ID as string,
      image: Frame50642,
      title: "try_it_app.imagery.title",
      subTitle: "try_it_app.imagery.subtitle",
      prepareUrl : true,
      tryItAppsLink:`HOSTapp/organizations/ORG_ID/PROPERTY_ID/image-catalog`
    },
    {
      id: process.env.REACT_APP_FINANCIALS_ID as string,
      image: Frame50875,
      title: "try_it_app.financials.title",
      subTitle: "try_it_app.financials.subtitle",
      tryItAppsLink: "https://financials.cropwise.com/",
      prepareUrl : false
    },
  ];

  const getOrgsAndProperties = async () => {
    const getAllOrganizationsResponse =
      await getAllOrganizationFromCurrentWorkspace(workspaceId);
    let orgId = '';
    let propertyId = '';
    if (
      getAllOrganizationsResponse?.status === 200 &&
      getAllOrganizationsResponse.data.content.length
    ) {
      const getAllPropertiesResponse = await getAllPropertiesByOrgIds(
        [getAllOrganizationsResponse.data.content[0].id],
        { size: 1 }
      );
      if (
        getAllPropertiesResponse?.status === 200 &&
        getAllPropertiesResponse.data.content.length
      ) {
        propertyId = getAllPropertiesResponse.data.content[0].id
      }
      orgId = getAllOrganizationsResponse.data.content[0].id;
    }
    processAppList(orgId, propertyId);
  };

  const prepareProductURL = (product: ProductBasicData, orgId: string, propertyId: string) => {
    const appPermitted = getIsAppPermitted(product.id);
    if (appPermitted) {
      const currentProduct: IDataForTryItApps | undefined = find(dataForTryItApps, { id: appPermitted });
      if (currentProduct && currentProduct.prepareUrl) {
        if (orgId && propertyId) {
          let appUrl = currentProduct.tryItAppsLink;
          appUrl = appUrl.replace('HOST', product.site_uri);
          appUrl = appUrl.replace('ORG_ID', orgId);
          appUrl = appUrl.replace('PROPERTY_ID', propertyId);
          currentProduct.tryItAppsLink = appUrl;
        } else {
          currentProduct.tryItAppsLink = product.site_uri;
        }
      }
      return currentProduct;
    }
  }

  const checkFarmSettingsProduct = (productsForTryItTips: any, orgId: string, propertyId: string) => {
    const farmSettingsTryItId = dataForTryItApps[0].id;
    const farmSettingsURL = isUK() ? `${process.env.FARM_SETTINGS_UK_URL}/` : `${process.env.FARM_SETTINGS_CW_URL}/`;
    const productsListIncludesFarmSettings = productsForTryItTips.find((product: any) => product.id === farmSettingsTryItId);
    if (!productsListIncludesFarmSettings) {
      const farmSettingsBasicData = { id: farmSettingsTryItId, site_uri: farmSettingsURL };
      const currentProduct = prepareProductURL(farmSettingsBasicData, orgId, propertyId);
      if (currentProduct) {
        productsForTryItTips.push(currentProduct);
      }
    }
  }

  const processAppList = (orgId:string, propertyId:string) => {
    const productsForTryItTips: any = [];
    products.forEach((product: ProductBasicData) => {
      const currentProduct = prepareProductURL(product, orgId, propertyId);
      if (currentProduct) {
        productsForTryItTips.push(currentProduct);
      }
    });
    checkFarmSettingsProduct(productsForTryItTips, orgId, propertyId);
    productsForTryItTips.sort((productA: any, productB: any) => productA.id.localeCompare(productB.id));
    setFilteredDataForTryItApps(productsForTryItTips);
    return productsForTryItTips;
  }

  useEffect(() => {
    getOrgsAndProperties();
  }, [workspaceId]);

  return (
    <Spin spinning={false}>
      <div className="try-it-apps-container">
        <div className="try-it-apps-image-container">
          {
            filteredDataForTryItApps.length ? <img src={filteredDataForTryItApps[selectedTipNumber - 1].image} />:<></>
          }
          
        </div>
        <div className="try-it-apps-content-box">
          <div className="try-it-apps-tip-number-title-box">
            {filteredDataForTryItApps.length > 1 && (
              <div className="try-it-apps-tip-number-box">
                {selectedTipNumber}/{filteredDataForTryItApps.length}
              </div>
            )}
            <div className="try-it-apps-title-box">
              {t(filteredDataForTryItApps[selectedTipNumber - 1]?.title)}
            </div>
          </div>
          <div className="try-it-apps-subtitle-box">
            {t(filteredDataForTryItApps[selectedTipNumber - 1]?.subTitle)}
          </div>
        </div>
        <div className="try-it-apps-buttons">
          <div className="try-it-app-box">
            <a
              href={
                filteredDataForTryItApps[selectedTipNumber - 1]?.tryItAppsLink
              }
              target="_blank"
            >
              {t('button.try_it')}
            </a>
          </div>
          {filteredDataForTryItApps.length > 1 && (
            <div className="try-it-apps-arrow-btns">
              <div
                style={{
                  cursor: selectedTipNumber === 1 ? "not-allowed" : "pointer",
                }}
                className="try-it-apps-move-back-arrow"
                onClick={() =>
                  selectedTipNumber === 1
                    ? ""
                    : setSelectedTipNumber(selectedTipNumber - 1)
                }
              >
                <img src={moveBackArrow} />
              </div>
              <div
                style={{
                  cursor:
                    selectedTipNumber === filteredDataForTryItApps.length
                      ? "not-allowed"
                      : "pointer",
                }}
                className="try-it-apps-move-forth-arrow"
                onClick={() =>
                  selectedTipNumber === filteredDataForTryItApps.length
                    ? ""
                    : setSelectedTipNumber(selectedTipNumber + 1)
                }
              >
                <img src={moveForthArrow} />
              </div>
            </div>
          )}
        </div>
      </div>
    </Spin>
  );
};
